import { ExternalLink } from 'react-external-link';

export default ExternalLink;
